import formatNameCaseWithSplitterAndSpacer from './formatNameCaseWithSplitterAndSpacer';
import formatUnderScoreToSpace from './formatUnderScoreToSpace';

/**
 * Returns formatted city name in title case with no underscores or dashes.
 * Trims leading/trailing whitespace so spaced input does not leave empty segments.
 * @param {object} opts
 * @param {string} opts.city - City name; leading/trailing spaces are trimmed
 * @returns {null|string} Title-cased city, or null if missing/blank/"null"
 */
const formatCity = (opts = {}) => {
  const { city } = opts;
  if (!city || typeof city !== 'string') {
    return null;
  }
  const trimmedCity = city.trim();
  if (!trimmedCity || trimmedCity.toLowerCase() === 'null') {
    return null;
  }
  const noscoreCity = formatUnderScoreToSpace({ string: trimmedCity });
  const nodashCity = noscoreCity.replace(/-/g, ' ').trim();
  return formatNameCaseWithSplitterAndSpacer({ name: nodashCity });
};

export default formatCity;
